
import React from 'react';

interface UserStatsTabProps {
  lists: any[];
  tasks: any[];
  totalPomodoros: number;
}

const UserStatsTab: React.FC<UserStatsTabProps> = ({ lists, tasks, totalPomodoros }) => {
  // Calculate stats based on tasks
  const totalTasks = tasks.length;

  return (
    <div className="space-y-4">
      <h4 className="text-lg font-medium text-gray-800 dark:text-gray-200">Your workload</h4>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg">
          <p className="text-sm text-gray-500 dark:text-gray-400">Lists</p>
          <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{lists.length}</p>
        </div>
        
        <div className="bg-gray-50 dark:bg-gray-800/50 p-4 rounded-lg">
          <p className="text-sm text-gray-500 dark:text-gray-400">Tasks</p>
          <p className="text-2xl font-semibold text-gray-900 dark:text-gray-100">{totalTasks}</p>
        </div>
      </div>
    </div>
  );
};

export default UserStatsTab;
